import React from 'react';
import Header from "../thema/tema1/component/Header";
import Footer from "../thema/tema1/component/Footer";
import SideMenu from "../thema/tema1/component/SideMenu";
import PageContext from "../thema/tema1/component/PageContext";

const active = {Home: "active"};

class Ardiye extends React.Component {
    componentDidMount() {

    }

    render(props) {
        const button = {
            marginTop: "0px",
            marginLeft: "10px",
            float: "left",
            width: "100px"
        };
        return (
            <div>
                <Header/>
                <SideMenu ardiye="active"/>
                <PageContext>
                    <form>
                        <div className="card card-primary">
                            <div className="card-header">
                                <h3 className="card-title">Ekle</h3>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-3">
                                        <label htmlFor="exampleInputEmail1">Tır Plaka</label>
                                        <input type="text" className="form-control" id="sinifadi"
                                               placeholder="Tır Plaka"/>
                                    </div>
                                    <div className="col-3">
                                        <label htmlFor="exampleInputEmail1">Ücret</label>
                                        <input type="text" className="form-control" id="sinifadi"
                                               placeholder="Ücret"/>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="card-footer">
                        <button type="submit" className="btn btn-primary">Kaydet</button>
                        </div>
                    </form>
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">
                                <button style={button} type="button"
                                        className="btn btn-block btn-outline-primary">TÜMÜNÜ YAZDIR
                                </button>
                            </h3>
                        </div>
                        <div className="card-body">
                            <table id="table" className="table table-bordered table-striped">
                                <thead>
                                <tr>
                                    <th>TIR PLAKA</th>
                                    <th>İŞLEM ÜCRETİ</th>
                                    <th>İŞLEMLER</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>41 ST 203</td>
                                    <td>3000 €</td>
                                    <td>
                                        <button style={button} type="button"
                                                className="btn btn-block btn-outline-primary">YAZDIR
                                        </button>
                                        <button style={button} type="button"
                                                className="btn btn-block btn-outline-info">DÜZENLE
                                        </button>
                                        <button style={button} type="button"
                                                className="btn btn-block btn-outline-danger">SİL
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>71 AAC 416</td>
                                    <td>3000 €</td>
                                    <td>
                                        <button style={button} type="button"
                                                className="btn btn-block btn-outline-primary">YAZDIR
                                        </button>
                                        <button style={button} type="button"
                                                className="btn btn-block btn-outline-info">DÜZENLE
                                        </button>
                                        <button style={button} type="button"
                                                className="btn btn-block btn-outline-danger">SİL
                                        </button>
                                    </td>
                                </tr>
                                </tbody>
                                <tfoot>
                                <tr>
                                    <th>TIR PLAKA</th>
                                    <th>FIRMA ADI</th>
                                    <th>İŞLEMLER</th>
                                </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </PageContext>
                <Footer/>
            </div>);
    }
}


export default Ardiye;
